(ns ncr.widgets.dropzone
  (:require
   [clojure.core.match :refer [match]]
   [lambdaisland.glogi :as log]
   [taoensso.encore :as e]
   [ncr.widgets.core :as w]
   [ncr.etc.util :as u]
   [ncr.etc.pf :as pf]
   [ncr.etc.rhf :as rhf]
   [camel-snake-kebab.core :as csk]
   ["react-dropzone" :as dz]))

(defn- keys->kebab-case [in]
  (e/map-keys csk/->kebab-case-keyword in))

(defn- transform-props [^js props]
  (-> props
    (js->clj)
    (keys->kebab-case)
    (merge
      {:ref (.-ref props)})))

(defn use-dropzone [opts]
  (let
    [opts
     (e/map-keys csk/->camelCase
       (-> opts
         (update :on-drop-accepted
           (fn [original]
             (fn [files _]
               (original (js->clj files)))))))
     ^js dz (dz/useDropzone (clj->js opts))]
    (-> (js->clj dz)
      (keys->kebab-case)
      (merge
        {:input-ref (.-inputRef dz)
         :root-ref (.-rootRef dz)

         :get-root-props
         (fn []
           (let [props ((.-getRootProps dz))]
             (w/merge-props
               (transform-props props)
               {:class :ncr-c-dropzone})))

         :get-input-props
         (fn []
           (let [props ((.-getInputProps dz))]
             (transform-props props)))}))))

